// extracted by mini-css-extract-plugin
export default {"success":"FormMessaging_success__p+-E3","error":"FormMessaging_error__NgUsq"};